import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { dAPI } from 'appSrc/api';
import { Icon, UserAvatar, InfiniteTable, DLMenu, DLSelect } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditUserModal from '../../Modals/User/EditUserModal';
import NewUserModal from '../../Modals/User/NewUserModal';
import { showModal, hideModal } from 'appSrc/redux/actions';
import { PrimaryButton, DLTextField } from 'appSrc/components/UI';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllUsersView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            users: [],
            searchValue: '',
            userInEdit: null,
            userInEditIndex: -1,
            userQueryObject: {
                page: 1,
                limit: 25,
                sort: '-userid',
                search: undefined,
            },
        };
    }

    componentDidMount() {
        this.loadUsers();
    }

    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }

    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.setState( ( prevState ) => {
                prevState.fetching = true;
                prevState.users = [];
                prevState.userQueryObject.page = 1;
                prevState.userQueryObject.search = this.state.searchValue || undefined;
                return prevState;
            } );
            this.loadUsers();
        }
    }

    onFilter = ( key, value ) => {
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.users = [];
            prevState.userQueryObject.page = 1;
            prevState.userQueryObject[ key ] = value;
            return prevState;
        } );
        this.loadUsers();
    }

    onSort = ( value ) => {
        if( this.state.userQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.setState( ( prevState ) => {
            prevState.fetching = true;
            prevState.users = [];
            prevState.userQueryObject.page = 1;
            prevState.userQueryObject.sort = value;
            return prevState;
        } );
        this.loadUsers();
    }

    loadUsers = () => {
        return this.props.getUsers( this.state.userQueryObject )
        .then( ( users ) => {
            this.setState( ( prevState ) => {
                prevState.fetching= false,
                prevState.users = prevState.users.concat( users ),
                prevState.userQueryObject.page++;
                return prevState;
            } );
            return users;
        } );
    }

    directUpdateUser = ( index, userid, data ) => {
        this.props.updateUser( userid, data )
        .then( ( user ) => {
            this.setState( ( prevState ) => {
                prevState.users[ index ] = user;
                return prevState;
            } );
        } );
    }

    openEditModal = ( index, user ) => {
        this.setState( { userInEdit: user, userInEditIndex: index } );
        this.props.showModal( 'editUserModal' );
    }

    onEditSubmit = ( updates ) => {
        var calls = [];
        if( updates.affil.length > 0 ) {
            for( var i = 0; i < updates.affil.length; i++ ) {
                calls.push( this.props.updateUserAffiliateCode( updates.affil[i].userid, updates.affil[i] ) );
            }
        }
        return Promise.all( calls )
        .then( () => {
            return this.props.updateUser( updates.user.userid, updates.user );
        } )
        .then( ( updatedUser ) => {
            this.setState( ( prevState ) => {
                prevState.users[ this.state.userInEditIndex ] = updatedUser;
                return prevState;
            } );
            updatedUser.categories = updates.user.categories;
            return updatedUser;
        } );
    }

    onEditClose = () => {
        this.props.hideModal( 'editUserModal' );
        this.setState( { userInEdit: null, userInEditIndex: -1 } );
    }

    openNewModal = () => {
        this.props.showModal( 'newUserModal' );
    }

    onNewSubmit = ( updates ) => {
        return this.props.createUser( updates.data )
        .then( ( confirmation ) => {
            var calls = [];
            if( updates.affil.length > 0 ) {
                for( var i = 0; i < updates.affil.length; i++ ) {
                    var affil = { ...updates.affil[ i ] };
                    affil.userid = confirmation.userid;
                    calls.push( this.props.updateUserAffiliateCode( confirmation.userid, affil ) );
                }
            }
            return Promise.all( calls );
        } )
        .then( () => {
            this.setState( ( prevState ) => {
                prevState.fetching = true;
                prevState.users = [];
                prevState.userQueryObject.page = 1;
                return prevState;
            } );
            this.loadUsers();
            return true;
        } );
    }

    onNewClose = () => {
        this.props.hideModal( 'newUserModal' );
    }

    render() {
        const { fetching, users, searchValue } = this.state;
        const userTypeOptions = [
            { text: '', value: null },
            { text: 'Featured Pro', value: 'featured' },
            { text: 'Verified Pro', value: 'verified creator' },
            { text: 'Unverified Pro', value: 'creator' },
            { text: 'Shopper', value: 'shopper' },
            { text: 'Admin', value: 'admin' },
        ];

        return (
            <section className={ style.usersPage }>
                <Helmet>
                    <title>Admin - Users</title>
                </Helmet>
                <div className={ style.head }>
                    <h2>Users</h2>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                        <PrimaryButton
                        label='+ Add New User'
                        onClick={ this.openNewModal } />
                    </div>
                    <div className={ style.tabs }>
                        <Link to='/admin/users' className={ style.tabOption }
                        data-active={ true }>View All</Link>
                        <Link to='/admin/users/featured' className={ style.tabOption }>Featured Users</Link>
                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allUsersList }>
                        <div className={ style.filters }>
                            <span style={ { marginRight: '20px' } }>Filter By</span>
                            <DLSelect placeholder='User Type' options={ userTypeOptions }
                            value={ this.state.userQueryObject[ 'usertype' ] }
                            onChange={ ( e, { value } ) => { this.onFilter( 'usertype', value ); } }
                            style={ { width: '170px' } }
                            noError />
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <InfiniteTable
                            loadMore={ this.loadUsers }
                            elementHeight={ 70 }>
                                { this.arrayTableRows( users ) }
                            </InfiniteTable>
                        }
                        { this.state.userInEdit &&
                            <EditUserModal closeModal={ this.onEditClose }
                            onSubmit={ this.onEditSubmit }
                            user={ this.state.userInEdit } />
                        }
                    </section>
                </div>
                <NewUserModal closeModal={ this.onNewClose }
                onSubmit={ this.onNewSubmit } />
            </section>
        );
    }


    arrayTableRows = ( users ) => {
        var rows = users.map( ( user, index ) => {
            var individualSlug = `/admin/users/${ user.userid }`;
            let profession = user.profession;
            if( profession ) {
                profession = profession.title;
            }
            return (
                <InfiniteTable.Row key={ user.userid } className='dl-table-body'>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }>
                        </Link>
                        <UserAvatar src={ user.avatar } size={ 40 }
                            style={ { marginRight: '0' } } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }>
                        </Link>
                        { user.displayName }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell>
                        <Link to={ individualSlug }>
                        </Link>
                        { profession }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }>
                        </Link>
                        <Icon source='fontAwesome' icon='fas/faCircle' style={ { color: user.deactivated ? 'red' : 'blue' } } />
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <Link to={ individualSlug }>
                        </Link>
                        { user.featured !== null ? ( <Icon source='fontAwesome' icon='fas/faCheck' style={ { color: 'inheirit' } } /> ) : null }
                    </InfiniteTable.Cell>
                    <InfiniteTable.Cell className={ style.actionsCell }>
                        <DLMenu
                        icon={ ( <Icon source='fontAwesome' className='dropdown' icon='fas/faEllipsisH' style={ { color: '#6461ec' } } faSize='2x' /> ) }
                        direction='left' >
                            <DLMenu.Item text='Edit'
                            onClick={ () => {
                                this.openEditModal( index, user );
                            } }/>
                            <DLMenu.Item text={ user.deactivated ? 'Activate' : 'Deactivate' }
                            onClick={ () => {
                                this.directUpdateUser( index, user.userid, {
                                    deactivated: !user.deactivated,
                                    displayName: user.displayName,
                                } );
                            } }/>
                            <DLMenu.Item text={ user.featured ? 'UnFeature' : 'Feature' }
                            onClick={ () => {
                                this.directUpdateUser( index, user.userid, {
                                    featured: !user.featured,
                                    displayName: user.displayName,
                                } );
                            } }/>
                        </DLMenu>
                    </InfiniteTable.Cell>
                </InfiniteTable.Row>
            );
        } );
        const currentSort = this.state.userQueryObject.sort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.onSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.onSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.onSort( value ); } } />
            );
        };
        rows.unshift( (
            <InfiniteTable.Row key='-1' className='dl-table-head'>
                <InfiniteTable.Cell></InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    DISPLAY NAME { sortIcon( 'displayName,userid' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    PRO TITLE { sortIcon( 'profession,displayName' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    ACTIVATED { sortIcon( 'deactivated,displayName' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>
                    FEATURED { sortIcon( 'featured,displayName' ) }
                </InfiniteTable.Cell>
                <InfiniteTable.Cell>ACTIONS</InfiniteTable.Cell>
            </InfiniteTable.Row>
        ) );

        return rows;
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        getUsers: ( queryObject ) => {
            return dAPI.get( '/admin/users', queryObject );
        },
        createUser: ( data ) => {
            data.user = dAPI.clean.admin.user( data.user );
            return dAPI.post( '/admin/users', data );
        },
        updateUser: ( userid, data ) => {
            return dAPI.patch( `/users/${ userid }`, dAPI.clean.admin.user( data ) );
        },
        updateUserAffiliateCode: ( userid, data ) => {
            return dAPI.post( `/users/${ userid }/affiliatecode`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllUsersView );
